import { Pipe, PipeTransform } from '@angular/core';

import * as momentNs from 'moment-timezone';
const moment = momentNs;

/**
 * Converts a date string to format
 * https://momentjs.com/timezone/
 *
 * __Usage :__
 *   day | ngxTime
 *
 * __Example :__
 *   {{ '2019-01-29T09:00:00+01:00' | ngxTime }}
 *   formats to: 09:00
 *
 * Module {@link TransformTimeModule}
 */

@Pipe({
    name: 'ngxTime'
})

export class TransformTimePipe implements PipeTransform {
    transform(date: string, format = 'HH:mm'): string {
        const moDate = moment.tz(date, 'Europe/London');

        if (moDate._isValid) {
            return moDate.format(format);
        }

        return date;
    }
}
